var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlusThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 2.66669H4.66683C3.93045 2.66669 3.3335 3.26364 3.3335 4.00002V12.6667C3.3335 13.4031 3.93045 14 4.66683 14H11.3335C12.0699 14 12.6668 13.4031 12.6668 12.6667V4.00002C12.6668 3.26364 12.0699 2.66669 11.3335 2.66669Z",
    stroke: "white",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10M6 8.66667H10M6 11.3333H8.66667",
    stroke: "white",
    strokeWidth: 0.666667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlusThree);
export default __webpack_public_path__ + "static/media/image-plus-three.56ccabfdb1980b17f28c705caedace38.svg";
export { ForwardRef as ReactComponent };